import type { StyleSystemProps } from '@withjoy/joykit';
import { InputV2 } from '@withjoy/joykit';
import type { ComponentProps } from 'react';
import React from 'react';

// Only the things the contract does not do: the muted text that darkens on hover and focus. The
// invalid ring itself is the contract's, keyed off `isInvalid`.
const inputWrapperErrorStyles: StyleSystemProps = {
  color: 'mono8',
  _hover: {
    color: 'mono14',
  },
  _focusWithin: {
    color: 'mono14',
  },
};

const inputStyles: StyleSystemProps = {
  color: 'mono14',
};

const inputStartElementStyles: StyleSystemProps = { paddingRight: '1px', color: 'inherit' };

export const Input = (props: ComponentProps<typeof InputV2>) => (
  <InputV2
    overrides={{
      Root: {
        props: props.isInvalid ? inputWrapperErrorStyles : undefined,
      },
      Input: {
        props: inputStyles,
      },
      StartElement: {
        props: inputStartElementStyles,
      },
      ...props.overrides,
    }}
    isFullWidth
    {...props}
  />
);
